module.exports = __webpack_public_path__ + "img/131ne.f9a9d31f.svg";